import React, { useState, Fragment, useRef } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
import _debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import AlarmIcon from '@mui/icons-material/Alarm';





import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import axios from "axios";
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import AttachmentIcon from '@mui/icons-material/Attachment';
import Grid from '@mui/material/Grid';
import Barcode from 'react-barcode';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Checkbox from '@mui/material/Checkbox';
import TextareaAutosize from '@mui/material/TextareaAutosize';
function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,

) {
    return { name, calories, fat, carbs };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),

];


const MangeWorkShopParticpantOrder = () => {
    const history = useHistory();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState('');

    const [permissions, setrPermissions] = useState([]);
    const [allData, setAllData] = useState([]);
    const [participantIndex, setParticipantIndex] = useState([]);
    const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);
    const [isButtonReminderDisabled, setIsButtonReminderDisabled] = useState(false);
    const [workshopUsedCoupeon, setWorkshopUsedCoupeon] = useState([]);
    const [copiedStates, setCopiedStates] = useState({});
    const [openModalReceipt, setOpenModalReceipt] = useState(false);

    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [openModalBank, setOpenModalBank] = useState(false);
    const [openModalView, setOpenModalView] = useState(false);
    const [openModalWorkshop, setOpenModalWorkshop] = useState(false);
    const [workshopTotalSeatCount, setWorkshopTotalSeatCount] = useState();
    const [participantSingleData, setParticipantSingleData] = useState({
        id: "",
        particent_workshop_categoy_id: "",
        name_title: "",
        particent_name: "",
        particent_saudi_council_no: "",
        particent_email: "",
        password: "",
        particent_profession: "",


    });
    const [showBarcode, setShowBarcode] = useState(null);
    const [printingId, setPrintingId] = useState(null);
    const printRef = useRef();



    const [selectedOptions, setSelectedOptions] = useState({});


    const handleClickVerify = () => {
        setShowAdditionalButtons(!showAdditionalButtons);
    };

    React.useEffect(() => {
        return () => {
            setAllData(rows)
        };
    }, []);
    const eventid = localStorage.getItem('eventid')
    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);



    React.useEffect(() => {
        axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wcategoryData = res.data.wpindex;

                setParticipantIndex(wcategoryData);

            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);





    const CustomFieldDelete = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        thisClicked.innerText = " Deleting..."
        axios.get(`api/status-list-customfield/${id}`).then(res => {
            if (res.data.status === 200) {
                //swal("Success", res.data.message, "success");
                thisClicked.closest("tr").remove();
            }
            else if (res.data.status === 404) {
                this.innText = "delete";
            }
        });
    }


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const filteredRows = rows.filter((row) =>
        Object.values(row).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )

    );
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const [filterPaymentStatus, setFilterPaymentStatus] = useState('all'); // 'all', 'paid', 'unpaid'
    const handleFilterPaymentStatusChange = (event) => {
        setFilterPaymentStatus(event.target.value);
    };

    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermID, setSearchTermID] = useState('');
    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleIDInputChange = (e) => {
        setSearchTermID(e.target.value);
    };


   
    const filteredPosts = participantIndex.filter((row) => {
        const idMatches = row.id && row.id.toString().toLowerCase() === searchTermID.toLowerCase();
        const nameMatches = row.particent_name && row.particent_name.toLowerCase().includes(searchTerm.toLowerCase());
        const emailMatches = row.particent_email && row.particent_email.toLowerCase().includes(searchTerm.toLowerCase());
        const phoneMatches = row.particent_phone_number && row.particent_phone_number.toLowerCase().includes(searchTerm.toLowerCase());

        const transRefNoMatches = row.wppyament && row.wppyament.some((wppyament) =>
            wppyament.trans_ref_no && wppyament.trans_ref_no.toLowerCase().includes(searchTerm.toLowerCase())
        );
        const paymentMedthodMatches = row.wppyament && row.wppyament.some((wppyament) =>
            wppyament.payment_method && wppyament.payment_method.toLowerCase().includes(searchTerm.toLowerCase())
        );
        const paymentTypeMatches = row.wppyament && row.wppyament.some((wppyament) =>
            wppyament.payment_type && wppyament.payment_type.toLowerCase().includes(searchTerm.toLowerCase())
        );
        const paymentStatusMatches = row.wppyament && row.wppyament.some((wppyament) => {
            const statusLowerCase = wppyament.status === 0 ? 'no' : 'yes';
            return searchTerm.toLowerCase().includes(statusLowerCase);
        });

        const paymentStatusPaidUnpaid = row.wppyament && row.wppyament.some((wppyament) => {
            if (filterPaymentStatus === 'all') {
                return true; // Always include when 'all' is selected
            } else if (filterPaymentStatus === 'paid') {
                return wppyament.status !== 0; // Include if payment is paid
            } else if (filterPaymentStatus === 'unpaid') {
                return wppyament.status === 0; // Include if payment is unpaid
            }
            return false;
        });

        /// New condition to check for wpcategory's workshop_category_title
        const categoryMatches = row.wpcategory && row.wpcategory.workshop_category_title &&
            row.wpcategory.workshop_category_title.toLowerCase().includes(searchTerm.toLowerCase());

            

            const workshopMatches = row.wpworkshop && row.wpworkshop.some((workshop) =>
                workshop.workshop_name && workshop.workshop_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        



        // Set finalResult based on conditions
        const finalResult = (!searchTermID || idMatches) && (nameMatches || emailMatches || phoneMatches || transRefNoMatches || paymentMedthodMatches || paymentTypeMatches || paymentStatusMatches|| categoryMatches || workshopMatches) && paymentStatusPaidUnpaid;

        return finalResult;
    });







    const totalRecords = participantIndex.length;
    const filteredRecordsCount = filteredPosts.length;




    const handleWorkshopDownloadCSV = () => {
        const csvData = convertToCSV(filteredPosts);
        const csvBlob = new Blob([csvData], { type: 'text/csv' });
        const csvUrl = window.URL.createObjectURL(csvBlob);
        const downloadLink = document.createElement('a');
        downloadLink.href = csvUrl;
        downloadLink.download = 'Workshop_participent_data.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    // Function to convert data to CSV format with specific fields
    // const convertToCSV = (data) => {
    //     // Define the fields you want to include in the CSV
    //     const fields = ['name_title', 'particent_name', 'particent_saudi_council_no', 'particent_email', 'payment_status', 'workshops']; // Fields to include

    //     // Create the CSV header
    //     const header = fields.join(',');

    //     // Create the CSV body with data for selected fields
    //     const body = data.map(row => {
    //         // Extract values for selected fields
    //         const filteredRow = fields.map(field => {
    //             if (field === 'payment_status') {
    //                 return row.wppyament && row.wppyament.some(wppyament => wppyament.status === 0) ? 'no' : 'yes';
    //             } else if (field === 'workshops') {
    //                 if (Array.isArray(row.wpworkshop)) {
    //                     // Extract and concatenate workshop codes and payment statuses
    //                     const workshopData = row.wpworkshop.map(workshop => `${workshop.workshop_code} (${workshop.payment_status === 0 ? 'Unpaid' : 'Paid'})`).join(', ');
    //                     return workshopData;
    //                 } else {
    //                     return ''; // Empty string if no workshops available
    //                 }
    //             } else {
    //                 return row[field] || ''; // Ensure to handle potential undefined values
    //             }
    //         });
    //         return filteredRow.join(',');
    //     }).join('\n');

    //     return `${header}\n${body}`;
    // };


    const convertToCSV = (data) => {
        // Define the mapping between original data keys and display names
        const fieldMappings = {
            'name_title': 'Title',
            'particent_name': 'Name',
            'particent_saudi_council_no': 'Saudi Council No',
            'particent_email': 'Email',
            'participant_phone_number': 'Mobile Number',
            'payment_status': 'Payment Status',
            'workshops': 'Workshops'
        };

        // Define the fields you want to include in the CSV
        const fields = Object.keys(fieldMappings);

        // Create the CSV header using the display names
        const header = fields.map(field => fieldMappings[field]).join(',');

        // Create the CSV body with data for selected fields
        const body = data.map(row => {
            // Extract values for selected fields
            const filteredRow = fields.map(field => {
                if (field === 'payment_status') {
                    return row.wppyament && row.wppyament.some(wppyament => wppyament.status === 0) ? 'no' : 'yes';
                } else if (field === 'workshops') {
                    if (Array.isArray(row.wpworkshop)) {
                        // Extract workshop codes and their payment statuses and concatenate them with commas and spaces
                        const workshopData = row.wpworkshop.map(workshop => `${workshop.workshop_code} (${workshop.payment_status === 0 ? 'Unpaid' : 'Paid'})`).join(', ');
                        return `"${workshopData}"`; // Enclose entire workshop data in double quotes
                    } else {
                        return ''; // Empty string if no workshops available
                    }
                } else {
                    return row[field] || ''; // Ensure to handle potential undefined values
                }
            });
            return filteredRow.join(',');
        }).join('\n');

        return `${header}\n${body}`;
    };













    const handleChange = (event, row) => {
        const { value } = event.target;
        setSelectedOptions((prevOptions) => ({
            ...prevOptions,
            [row.id]: value,
        }));
        handleSelection(value, row);
    };
    // const handleChange = (event, row) => {
    //     const { value } = event.target;
    //     setSelectedOptions((prevOptions) => ({
    //         ...prevOptions,
    //         [row.id]: prevOptions[row.id] === value ? '' : value, // Reset if same option is clicked again
    //     }));
    //     handleSelection(value, row);
    // };

    const handleSelection = (value, row) => {
        // Add logic based on the selected value and the row information
        switch (value) {
            case 'receipt':
                handleClickReceipt(row);
                break;
            case 'bank':
                handleClickBank(row);
                break;

            case 'qrcodeshow':
                handleClickQrCodeShow(row);
                break;
            // case 'cash':
            //     handleClickCash(row);
            //     break;

            default:
                break;
        }
    };

    const isCheckboxDisabled = (workshop) => {
        const getWorkshop = workshop.workshop;
        const checkWorkshopSeat = workshopTotalSeatCount?.filter(ws => ws.workshop_id === getWorkshop.id).length;
        const isSeatLimitReached = checkWorkshopSeat >= getWorkshop.workshop_no_ofseats;
        let seatLimitMessage = "";
        if (isSeatLimitReached) {
            seatLimitMessage = `${checkWorkshopSeat} All Seats Full`;
        }
        const isDisabled = isSeatLimitReached;
        return { isDisabled, seatLimitMessage };
    };



    // const isAnyWorkshopDisabled = () => {
    //     return singleWorkShopCategory.work_shops.some(workshop =>
    //         isCheckboxDisabled(workshop).isDisabled
    //     );
    // };

    const handleClickView = (id) => {
        axios.get(`api/workshop-participant-show/${eventid}/${id}`).then(res => {
            if (res.status === 200) {
                const data = res.data.wsps;
                setParticipantSingleData(data);


            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        })

        setOpenModalView(true);
    };
    const handleCloseModalView = () => {
        setOpenModalView(false);
    };


    const handleClickViewWorkshops = (id) => {
        axios.get(`api/workshop-participant-show/${eventid}/${id}`).then(res => {
            if (res.status === 200) {
                const data = res.data.wsps;
                setParticipantSingleData(data)
                setWorkshopTotalSeatCount(res.data.totalSeatCount);

            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        })

        setOpenModalWorkshop(true);
    };

    const handleCloseModalWorkshop = () => {
        setOpenModalWorkshop(false);
    };
    const [checkedWorkshops, setCheckedWorkshops] = useState({});

    const handleWrokshopCheckboxChange = (workshopId) => {
        //console.log(workshopId)
        setCheckedWorkshops(prevState => ({
            ...prevState,
            [workshopId]: !prevState[workshopId] // Toggle the checked state
        }));
    };

    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);

    React.useEffect(() => {
        // Check if at least one workshop is selected
        const hasCheckedWorkshops = Object.values(checkedWorkshops).some(isChecked => isChecked);
        setIsSaveButtonDisabled(!hasCheckedWorkshops);
    }, [checkedWorkshops]);

    // const isCheckboxDisabled = (workshop) => {
    //     const getWorkshop = workshop.workshop;
    //     const checkWorkshopSeat = workshopTotalSeatCount?.filter(workshop => workshop.workshop_id === getWorkshop.id).length;
    //     const isSeatLimitReached = checkWorkshopSeat >= getWorkshop.workshop_no_ofseats;
    //     //console.log("workshopTotalSeatCount" ,workshopTotalSeatCount);
    //     let seatLimitMessage = "";
    //     if (isSeatLimitReached) {
    //         seatLimitMessage = `${checkWorkshopSeat} All Seats Full`;
    //     }
    //     const isDisabled = isSeatLimitReached;
    //     return { isDisabled, seatLimitMessage };
    // };





    //coupons
    React.useEffect(() => {
        axios.get(`api/workshop-participant-used-coupeona?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const usedCoupen = res.data.usedCoupons;
                setWorkshopUsedCoupeon(usedCoupen);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
    const copyCoupon = (couponCode) => {
        navigator.clipboard
            .writeText(couponCode)
            .then(() => {
                setCopiedStates(prevState => ({ ...prevState, [couponCode]: true }));
                setTimeout(() => {
                    setCopiedStates(prevState => ({ ...prevState, [couponCode]: false }));
                }, 3000);
            })
            .catch((err) => {
                console.log(err.message);
            });
    };



    const grandTotalViewWorkshopAmount = participantSingleData?.wpworkshop?.reduce((acc, workshop) => {
        if (workshop.workshop_amount) {
            return acc + parseFloat(workshop.workshop_amount);
        }
        return acc;
    }, 0);
    // const totalViewWorkshopAmount = participantSingleData?.wpworkshop?.reduce((acc, workshop) => {
    //     if (workshop.workshop_amount) {
    //         return acc + parseFloat(workshop.workshop_amount);
    //     }
    //     return acc;
    // }, 0);

    //let totalViewWorkshopAmount = 0;
    let totalDiscountedAmount = 0;

    participantSingleData?.wpworkshop?.forEach(workshop => {
        // Initialize variable for discounted amount
        let discountedAmount = parseFloat(workshop.workshop_amount);

        // Calculate discounted amount for the current workshop
        if (participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0) {
            participantSingleData.coupon_codes
                .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                .forEach(coupon => {
                    // Determine the discount based on the coupon type
                    let discount = 0;
                    if (coupon.coupon_discount_type === 'fixed') {
                        discount = parseFloat(coupon.coupon_amount);
                    } else if (coupon.coupon_discount_type === 'percentage') {
                        // Calculate the percentage discount
                        const percentage = parseFloat(coupon.coupon_amount);
                        discount = (parseFloat(workshop.workshop_amount) * percentage) / 100;
                    }

                    // Calculate the final amount after discount
                    discountedAmount -= discount;
                });
        }

        // Add discounted amount for the current workshop to the total discounted amount
        totalDiscountedAmount += discountedAmount;
    });




    let totalUnPaidWorkshopAmount = 0;
    // const totalUnPaidWorkshopAmount = participantSingleData?.wpworkshop?.reduce((acc, workshop) => {
    //     if (workshop.payment_status === 0 && workshop.workshop_amount) {
    //         return acc + parseFloat(workshop.workshop_amount);
    //     }
    //     return acc;
    // }, 0);

    // Calculate total discounted amount across all workshops
    participantSingleData?.wpworkshop?.forEach(workshop => {
        // Check if workshop payment status is unpaid and workshop amount exists
        if (workshop.payment_status === 0 && workshop.workshop_amount) {
            // Initialize variable for discounted amount
            let discountedAmount = parseFloat(workshop.workshop_amount);

            // Calculate discounted amount for the current workshop
            if (participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0) {
                participantSingleData.coupon_codes
                    .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                    .forEach(coupon => {
                        // Determine the discount based on the coupon type
                        let discount = 0;
                        if (coupon.coupon_discount_type === 'fixed') {
                            discount = parseFloat(coupon.coupon_amount);
                        } else if (coupon.coupon_discount_type === 'percentage') {
                            // Calculate the percentage discount
                            const percentage = parseFloat(coupon.coupon_amount);
                            discount = (parseFloat(workshop.workshop_amount) * percentage) / 100;
                        }

                        // Calculate the final amount after discount
                        discountedAmount -= discount;
                    });
            }

            // Add discounted amount for the current workshop to the total discounted amount
            totalUnPaidWorkshopAmount += discountedAmount;
        }
    });









    // const totalPaidWorkshopAmount = participantSingleData?.wpworkshop?.reduce((acc, workshop) => {
    //     if (workshop.payment_status === 1 && workshop.workshop_amount) {
    //         return acc + parseFloat(workshop.workshop_amount);
    //     }
    //     return acc;
    // }, 0);
    let totalPaidWorkshopAmount = 0;
    participantSingleData?.wpworkshop?.forEach(workshop => {
        // Check if workshop payment status is unpaid and workshop amount exists
        if (workshop.payment_status === 1 && workshop.workshop_amount) {
            // Initialize variable for discounted amount
            let discountedAmount = parseFloat(workshop.workshop_amount);

            // Calculate discounted amount for the current workshop
            if (participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0) {
                participantSingleData.coupon_codes
                    .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                    .forEach(coupon => {
                        // Determine the discount based on the coupon type
                        let discount = 0;
                        if (coupon.coupon_discount_type === 'fixed') {
                            discount = parseFloat(coupon.coupon_amount);
                        } else if (coupon.coupon_discount_type === 'percentage') {
                            // Calculate the percentage discount
                            const percentage = parseFloat(coupon.coupon_amount);
                            discount = (parseFloat(workshop.workshop_amount) * percentage) / 100;
                        }

                        // Calculate the final amount after discount
                        discountedAmount -= discount;
                    });
            }

            // Add discounted amount for the current workshop to the total discounted amount
            totalPaidWorkshopAmount += discountedAmount;
        }
    });


    const totalViewWorkshopAmount = 0;
    const totalDiscountedAmountFormatted = totalDiscountedAmount.toFixed(2);
    const grandTotalViewWorkshopAmountFormatted = !isNaN(grandTotalViewWorkshopAmount) ? grandTotalViewWorkshopAmount.toFixed(2) : 0;
    const totalUnPaidWorkshopAmountFormatted = totalUnPaidWorkshopAmount.toFixed(2);
    // const totalDiscountedAmountFormatted = totalDiscountedAmount.toFixed(2);
    const totalViewWorkshopAmountFormatted = !isNaN(totalViewWorkshopAmount) ? totalViewWorkshopAmount.toFixed(2) : 0;
    const totalPaidWorkshopAmountFormatted = !isNaN(totalPaidWorkshopAmount) ? totalPaidWorkshopAmount.toFixed(2) : 0;
    //const totalUnPaidWorkshopAmountFormatted = !isNaN(totalPaidWorkshopAmount) ? totalUnPaidWorkshopAmount.toFixed(2) : 0;




    const [tabValueReceipt, setTabValueReceipt] = useState(0);
    const [tabsDataReceipt, setTabsDataReceipt] = useState([]);

    const bankReferanceNo = tabsDataReceipt.map(tab => tab.label);
    const bankNameforVeri = tabsDataReceipt.map(tab => tab.content);


    const handleWorkshopStatusSubmit = () => {

        const data = {
            eventid,
            particent_id: `${participantSingleData.id || ""}`,
            verifiWorkshop: checkedWorkshops,
            //totalAmount: totalViewWorkshopAmount,
            totalAmount: totalDiscountedAmountFormatted,
            paidAmount: totalPaidWorkshopAmountFormatted,
            reminingAmount: totalUnPaidWorkshopAmountFormatted,
            particent_bank: addBank.bank_name ? addBank.bank_name : bankNameforVeri.join(' , '), // Conditionally set particent_bank
            particent_ref_no: addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join(' , '),
        };

        const id = participantSingleData.id;

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/workshop-particepant-workshop-status-verification/${id}`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');
                    // Fetch the updated data after successful submission
                    //setCheckedWorkshops("")
                    axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.wpindex;
                            setParticipantIndex(wcategoryData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                        }
                    });

                    history.push('/admin/workshop/manage-particpant-order');
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });


        });
        setCheckedWorkshops("")
        setOpenModalWorkshop(false); // Close the dialog box
        // Add your logic to submit the form or perform any other action
    };











    const [openModalWorkshopRecepit, setOpenModalWorkshopRecepit] = useState(false);


    const handleClickOpenlWorkshopRecepit = () => {
        setOpenModalWorkshopRecepit(true);
    };

    const handleClose = () => {
        setOpenModalWorkshopRecepit(false);

    };


    React.useEffect(() => {
        // Check if participantSingleData and wpbank_pay_tran are defined and if wpbank_pay_tran is an array
        if (participantSingleData && Array.isArray(participantSingleData.wpbank_pay_tran)) {
            // Map over wpbank_pay_tran if it's defined and an array
            const bankPaymentData = participantSingleData.wpbank_pay_tran.map((bankDetails, key) => ({
                label: bankDetails.trans_ref_no,
                content: bankDetails.bank_name,
                imageUrl: bankDetails.image_url ? bankDetails.image_url : ''
                // imageUrl: participantSingleData.base_url ? `${participantSingleData.base_url}/workshop/${bankDetails.receipt_image}` : ''
            }));

            // Update state with bankPaymentData
            setTabsDataReceipt(bankPaymentData);
        } else {
            // Handle case where participantSingleData or wpbank_pay_tran is undefined or not an array
            console.log("Error: participantSingleData or wpbank_pay_tran is undefined or not an array");
        }
    }, [participantSingleData]); // Add participantSingleData to the dependency array to ensure useEffect runs when it changes




    const handleReceiptTabChange = (event, newValue) => {
        setTabValueReceipt(newValue);
    };




    const [addReceipt, setAddReceipt] = useState({
        particent_id: `${participantSingleData.id || ""}`,
        particent_bank: "",
        particent_ref_no: "",

    });
    const handleInputReceipt = (e) => {
        setAddReceipt({ ...addReceipt, [e.target.name]: e.target.value });

    }

    const addReceiptData = (e) => {
        e.preventDefault();
        const receiptVerifictions = "receiptVerifictions";
        //on this comment replace the banksubmit
        const data = {
            eventid,
            particent_id: `${participantSingleData.id || ""}`,
            particent_bank: addReceipt.particent_bank, // Conditionally set particent_bank
            particent_ref_no: addReceipt.particent_ref_no,
            receiptVerifictions,
            verifiWorkshop: checkedWorkshops,
            //totalAmount: totalViewWorkshopAmount,
            totalAmount: totalDiscountedAmountFormatted,

        }
        const id = participantSingleData.id;



        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/workshop-particepant-receipt-verification/${id}`, data).then(res => {


                if (res.data.status === 200) {

                    swal('Success', "Verify SuccessFully Through Receipt", 'success');
                    // Fetch the updated data after successful submission
                    axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.wpindex;
                            setParticipantIndex(wcategoryData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                        }
                    });

                    history.push('/admin/workshop/manage-particpant-order');
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });


        });
        setAddReceipt({
            particent_id: `${participantSingleData.id || ""}`,
            particent_bank: "",
            particent_ref_no: "",
        });


        setCheckedWorkshops("")
        setOpenModalReceipt(false);
    };

    const handleClickReceipt = (row) => {
        const strconfirm = window.confirm("Are you sure you want to verify..");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            const id = row.id;
            axios.get(`api/workshop-participant-show/${eventid}/${id}`).then(res => {
                if (res.status === 200) {
                    const data = res.data.wsps;
                    setParticipantSingleData(data);
                    setWorkshopTotalSeatCount(res.data.totalSeatCount);

                } else {
                    swal('Error', "Check API Something Wrong", 'error');
                }
            })
        }


        setOpenModalReceipt(true);

    };


    const handleCloseModal = () => {
        setOpenModalReceipt(false);
    };
    const handlechangeReceipt = (e) => {
        setAddReceipt({ ...addReceipt, [e.target.name]: e.target.value });
    }



    const [updatedParticipant, setUpdatedParticipant] = useState(null);
    const [refreshTable, setRefreshTable] = useState(false);
    const [addBank, setAddBank] = useState({
        particent_id: `${participantSingleData.id || ""}`,
        bank_name: "",
        trans_ref_no: "",

    });

    const handlechangeBank = (e) => {
        setAddBank({ ...addBank, [e.target.name]: e.target.value });
    }


    const submitBankData = (e) => {
        e.preventDefault();
        const bankVerifictions = "bankVerifictions";


        const data = {
            eventid,
            particent_id: `${participantSingleData.id || ""}`,
            particent_bank: addBank.bank_name ? addBank.bank_name : bankNameforVeri.join(' , '), // Conditionally set particent_bank
            particent_ref_no: addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join(' , '),
            bankVerifictions,
            verifiWorkshop: checkedWorkshops,
            //totalAmount: totalViewWorkshopAmount,

            totalAmount: totalDiscountedAmountFormatted,
            paidAmount: totalPaidWorkshopAmountFormatted,
            reminingAmount: totalUnPaidWorkshopAmountFormatted,



        }
        const id = participantSingleData.id;


        setIsSubmitting(true);

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/workshop-particepant-bank-verification/${id}`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');
                    // Fetch the updated data after successful submission
                    axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.wpindex;
                            setParticipantIndex(wcategoryData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                        }
                    });

                    history.push('/admin/workshop/manage-particpant-order');
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });


        });


        // // swal("Success", "Verifie SuccessFully Through Bank", "success")

        setAddBank({
            particent_id: `${participantSingleData.id || ""}`,
            bank_name: "",
            trans_ref_no: "",
        });
        setCheckedWorkshops("")


        // Close the modal
        setOpenModalBank(false);

    };

    React.useEffect(() => {
        if (updatedParticipant) {
            setParticipantIndex(prevParticipantIndex => {
                return prevParticipantIndex.map(item => (item.id === updatedParticipant.id ? updatedParticipant : item));
            });
        }
    }, [updatedParticipant]);




    const handleClickBank = (row) => {

        const strconfirm = window.confirm("Are you sure you want to verify.. ");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            const id = row.id;
            axios.get(`api/workshop-participant-show/${eventid}/${id}`).then(res => {
                if (res.status === 200) {
                    const data = res.data.wsps;

                    setParticipantSingleData(data);
                    data.wppyament.map((val) => {
                        setAddBank(val);
                    });
                    setWorkshopTotalSeatCount(res.data.totalSeatCount);

                } else {
                    swal('Error', "Check API Something Wrong", 'error');
                }
            })
        }



        setOpenModalBank(true);
    };
    const handleCloseModalBank = () => {
        setOpenModalBank(false);
    };





    const handleClickQrCodeShow = (row) => {
        const id = row.id;
        const qrStatusOn = "qrStatusOn";
        const data = {
            eventid,
            particent_id: id,
            qrStatusOn,
            verifiWorkshop: "empty",


        }

        const strconfirm = window.confirm("Are you sure you want to verify..");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            axios.get('/sanctum/csrf-cookie').then(response => {

                axios.post(`/api/workshop-particepant-status-qrcodestatus/${id}`, data).then(res => {

                    if (res.data.status === 200) {


                        swal('Success', res.data.message, 'success');
                        // Fetch the updated data after successful submission
                        axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
                            if (res.status === 200) {
                                const wcategoryData = res.data.wpindex;
                                setParticipantIndex(wcategoryData);
                            } else {
                                swal('Error', 'Check API Something Wrong', 'error');
                            }
                        });

                        history.push('/admin/workshop/manage-particpant-order');
                    }
                    else {

                        setAddBank({ ...addBank, error_list: res.data.validate_error })

                    }

                });


            });


        }
    }


    const handleClickCash = (row) => {
        const id = row.id;

        const cashVerifictions = "cashVerifictions";


        const data = {
            eventid,
            particent_id: `${participantSingleData.id || ""}`,
            particent_bank: addBank.particent_bank,
            particent_ref_no: addBank.particent_ref_no,
            cashVerifictions,
            verifiWorkshop: checkedWorkshops,
            totalAmount: totalDiscountedAmountFormatted,

        }



        const strconfirm = window.confirm("Are you sure you want to verify..");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            axios.get('/sanctum/csrf-cookie').then(response => {

                axios.post(`/api/workshop-particepant-bank-verification/${id}`, data).then(res => {

                    if (res.data.status === 200) {


                        swal('Success', "Verifie SuccessFully Through Cash", 'success');
                        // Fetch the updated data after successful submission
                        axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
                            if (res.status === 200) {
                                const wcategoryData = res.data.wpindex;
                                setParticipantIndex(wcategoryData);
                            } else {
                                swal('Error', 'Check API Something Wrong', 'error');
                            }
                        });

                        history.push('/admin/workshop/manage-particpant-order');
                    }
                    else {

                        setAddBank({ ...addBank, error_list: res.data.validate_error })

                    }

                });


            });


        }


    };



    const [openModalChallan, setOpenModalChallan] = useState(false);
    const [challandata, setChallandata] = useState('');

    const handleModalChallan = (wppyament) => {
        const id = wppyament.id;

        axios.get(`api/workshop-participant-pyament-challan/${eventid}/${id}`).then(res => {
            if (res.status === 200) {
                const data = res.data.wsppc;
                setChallandata(data);
            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        });

        setOpenModalChallan(true);
    };





    const [openModalBankVeriChallan, setOpenModalBankVeriChallan] = useState(false);


    const handleModalBankReciept = (bankDeatials) => {
        // const id = bankDeatials.id;
        // alert(`bank Details: ${id}`)
        setOpenModalBankVeriChallan(true);
    };

    const handleCloseModalBankVeriChallan = () => {
        setOpenModalBankVeriChallan(false);
    };




    const handleCloseModalChallan = () => {
        setOpenModalChallan(false);
    };


    const handleClickReminderEmail = (row) => {

        const id = row.id;
        // alert(`Function accessed with ID: ${id}`);
        const data = {
            eventid,

        }
        setIsButtonReminderDisabled(true);
        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/workshop-participant-reminder-email-send/${id}`, data).then(res => {

                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');

                    // Fetch the updated data after successful submission
                    axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.wpindex;
                            setParticipantIndex(wcategoryData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                            setIsButtonReminderDisabled(false);
                        }
                    });
                    setIsButtonReminderDisabled(false);

                    //history.push('/admin/workshop/manage-particpant-order');
                }
                else {

                    swal('Success', "Error", 'success');
                    setIsButtonReminderDisabled(false);

                }

            });


        });




        //swal('Success', "Submit Reminder Email", 'success');
    };


    const handleClickReminderSMS = () => {

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/workshop-particpant-send-message/`).then(res => {

                if (res.data.status === 200) {

                    swal('Success', res.data.message, 'success');


                }
                else {

                    swal('Success', "Message Not Send", 'success');

                }

            });


        });

        // swal('Success', "Submit Reminder SMS", 'success');
    };




    //Qrcode Start

    // const handleBarcodeClick = (row) => {

    //     setPrintingId(row.id);
    //     const id = row.id;

    //     const title = row.name_title;
    //     const name = row.particent_name;


    //     const wpworkshopArray = row.wpworkshop;


    //     // const ActiveWorkshop = wpworkshopArray && wpworkshopArray.map((wpCode) => wpCode.workshop_code);
    //     // const ActiveWorkshop = wpworkshopArray && wpworkshopArray
    //     //     .filter(wpCode => wpCode.payment_status === 1)
    //     //     .map(wpCode => wpCode.workshop_code);


    //     // const ActiveWorkshop = wpworkshopArray && wpworkshopArray
    //     //     .filter(wpCode => wpCode.payment_status === 1)
    //     //     .map(wpCode => wpCode.workshop_name);

    //     const ActiveWorkshop = wpworkshopArray
    //     ? wpworkshopArray.filter(wpCode => wpCode.payment_status === 1)
    //         .map(wpCode => {
    //             const workshopTitle = wpCode.workshop_name;

    //             // Get all room matches (parentheses)
    //             const roomMatches = workshopTitle.match(/\(([^)]+)\)/g); // Match all parentheses
    //             const lastRoomPart = roomMatches && roomMatches.length > 0 ? roomMatches[roomMatches.length - 1] : ''; // Get the last room part

    //             // Remove all room parts for processing
    //             const titleWithoutRooms = workshopTitle.replace(/\s*\([^)]+\)/g, '').trim(); // Remove all parentheses parts

    //             const words = titleWithoutRooms.split(' ');

    //             let formattedTitle;
    //             if (words.length > 3) {
    //                 // Get the first three words only
    //                 formattedTitle = words.slice(0, 3).join(' ') + ' '; // Add a space after the first three words
    //             } else {
    //                 // Return the title as is
    //                 formattedTitle = titleWithoutRooms;
    //             }

    //             // Combine the formatted title with the last room part
    //             return `${formattedTitle}${lastRoomPart}`.trim(); // Trim to remove any extra spaces
    //         })
    //     : [];





    //     const printWindow = window.open();

    //     printWindow.onload = () => {
    //         // Call window.print() to trigger the print dialog
    //         printWindow.print();
    //     };

    //     const workshopCodes = participantSingleData.wpworkshop
    //         ? participantSingleData.wpworkshop.map((workshop) => workshop.workshop_code)
    //         : [];

    //     const workshopDivs = ActiveWorkshop.map(workshop => `
    //         <div style="text-align: center; line-height: 1; margin: 1; padding: 0;">
    //             ${workshop}
    //         </div>
    //     `).join('');

    //     printWindow.document.write(`

    //     <html>
    //     <head>
    //       <title>Print</title>
    //       <style>
    //       body {
    //         text-align: center;
    //         margin: 0;
    //         padding: 20px;
    //       }

    //       #content {
    //         display: flex;
    //         flex-direction: column;
    //         align-items: center;
    //         justify-content: center;
    //         text-align: left;
    //         padding-top: 190px;
    //       }

    //       #printButton {
    //         display: block;
    //         position: fixed;
    //         top: 0;
    //         right: 0;
    //         margin: 20px;
    //         padding: 10px;
    //         background-color: green;
    //         color: white;
    //         border: none;
    //         cursor: pointer;
    //       }

    //       @media print {
    //         #printButton {
    //           display: none;
    //         }

    //         /* Remove default browser headers and footers */
    //         @page {
    //           size: auto;
    //           margin: 0;
    //         }

    //       }
    //     </style>
    //       <script type="text/javascript" src="https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"></script>
    //       <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.4/dist/JsBarcode.all.min.js"></script>
    //     </head>
    //     <body>
    //       <!-- Print Button -->
    //       <button id="printButton" onclick="window.print()">Print</button>

    //       <div id="content">

    //         <!-- Include a QR code with the record ID -->
    //         <div id="qrcode" style="margin-bottom: 0.5em;"></div>
    //          ${workshopDivs} 

    //         <h3 style="text-align: center; line-height: 1.5; margin: 0;">ID: ${id}</h3>
    //         <h3 style="text-align: center; line-height: 1; margin: 0;">${name}</h3>



    //         <!-- Include a barcode with the record ID
    //         <div id="barcode-container">
    //           <svg id="barcode"></svg>
    //         </div>
    //         -->



    //         <script type="text/javascript">
    //         if (typeof JsBarcode !== 'undefined') {
    //             // Get the SVG element for the QR code
    //             const qrcodeSvg = document.getElementById("qrcode");

    //             // Generate QR code using QRCode
    //             var qrcode = new QRCode(qrcodeSvg, {
    //               text: '${id}',
    //               width: 128,
    //               height: 128,

    //             });



    //             // Get the SVG element for the barcode
    //             const barcodeSvg = document.getElementById("barcode");

    //             // Generate barcode using JsBarcode
    //             JsBarcode(barcodeSvg, '${id}', {
    //               format: "CODE128",
    //               displayValue: true,
    //               fontSize: 14,
    //               textMargin: 10,
    //             });

    //             const textElement = barcodeSvg.querySelector('text');
    //             if (textElement) {
    //               textElement.remove();
    //             }
    //             // Set the desired width directly in the SVG element for the barcode
    //             barcodeSvg.setAttribute('width', '128'); // Adjust the width here

    //             // Set the desired height directly in the SVG element for the barcode
    //             barcodeSvg.setAttribute('height', '80'); // Adjust the height here

    //             // Disable aspect ratio preservation for the barcode
    //             barcodeSvg.setAttribute('preserveAspectRatio', 'none');

    //             // Add spacing between the QR code and the barcode
    //             qrcodeSvg.style.marginBottom = '20px'; // Adjust the margin here
    //           } else {
    //             console.error('JsBarcode library not loaded.');
    //           }
    //         </script>
    //       </div>
    //     </body>
    //   </html>
    // `);
    //     // Close the print window after printing
    //     printWindow.document.close();


    // };

    //end



    const handleBarcodeClick = (row) => {

        setPrintingId(row.id);
        const id = row.id;

        const title = row.name_title;
        const name = row.particent_name;


        const wpworkshopArray = row.wpworkshop;


        // const ActiveWorkshop = wpworkshopArray && wpworkshopArray.map((wpCode) => wpCode.workshop_code);
        // const ActiveWorkshop = wpworkshopArray && wpworkshopArray
        //     .filter(wpCode => wpCode.payment_status === 1)
        //     .map(wpCode => wpCode.workshop_code);


        // const ActiveWorkshop = wpworkshopArray && wpworkshopArray
        //     .filter(wpCode => wpCode.payment_status === 1)
        //     .map(wpCode => wpCode.workshop_name);

        const ActiveWorkshop = wpworkshopArray
            ? wpworkshopArray.filter(wpCode => wpCode.payment_status === 1)
                .map(wpCode => {
                    const workshopTitle = wpCode.workshop_name;

                    // Get all room matches (parentheses)
                    const roomMatches = workshopTitle.match(/\(([^)]+)\)/g); // Match all parentheses
                    const lastRoomPart = roomMatches && roomMatches.length > 0 ? roomMatches[roomMatches.length - 1] : ''; // Get the last room part

                    // Remove all room parts for processing
                    const titleWithoutRooms = workshopTitle.replace(/\s*\([^)]+\)/g, '').trim(); // Remove all parentheses parts

                    const words = titleWithoutRooms.split(' ');

                    let formattedTitle;
                    if (words.length > 3) {
                        // Get the first three words only
                        formattedTitle = words.slice(0, 3).join(' ') + ' '; // Add a space after the first three words
                    } else {
                        // Return the title as is
                        formattedTitle = titleWithoutRooms;
                    }

                    // Combine the formatted title with the last room part
                    return `${formattedTitle}${lastRoomPart}`.trim(); // Trim to remove any extra spaces
                })
            : [];





        const printWindow = window.open();

        printWindow.onload = () => {
            // Call window.print() to trigger the print dialog
            printWindow.print();
        };

        const workshopCodes = participantSingleData.wpworkshop
            ? participantSingleData.wpworkshop.map((workshop) => workshop.workshop_code)
            : [];

        const workshopDivs = ActiveWorkshop.map(workshop => `
            <div style="text-align: center; line-height: 1; margin: 1; padding: 0;">
                ${workshop}
            </div>
        `).join('');

        printWindow.document.write(`
            <html>
            <head>
              <title>Print</title>
              <style>
                body {
                  text-align: center;
                  margin: 0;
                  padding: 20px;
                }
              
                #content {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  text-align: left;
                  padding-top: 190px;
                }
              
                #printButton {
                  display: block;
                  position: fixed;
                  top: 0;
                  right: 0;
                  margin: 20px;
                  padding: 10px;
                  background-color: green;
                  color: white;
                  border: none;
                  cursor: pointer;
                }
              
                @media print {
                  #printButton {
                    display: none;
                  }
                  
                  /* Remove default browser headers and footers */
                  @page {
                    size: auto;
                    margin: 0;
                  }
                  
                }
                
                h3 {
                  line-height: 1.5; /* Adjust line height as needed */
                  margin: 0; /* Ensure no margin to keep it tidy */
                }
                
                #qrcode {
                  margin-top: 20px; /* Add margin above QR code */
                  margin-bottom: 20px; /* Add margin below QR code */
                }
          
                .workshop-div {
                  margin-top: 15px; /* Add margin above workshop titles */
                }
              </style>
              <script type="text/javascript" src="https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"></script>
              <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.4/dist/JsBarcode.all.min.js"></script>
            </head>
            <body>
              <!-- Print Button -->
              <button id="printButton" onclick="window.print()">Print</button>
          
              <div id="content">
                <!-- Include the name and ID above the QR code -->
                <h3>ID: ${id}</h3>
                <h3>${name}</h3>
                
                <!-- Include a QR code with the record ID -->
                <div id="qrcode" style="margin-bottom: 0.5em;"></div>
                
                <!-- Include workshop titles -->
                <div class="workshop-div">
                  ${workshopDivs} 
                </div>
          
                <!-- Include a barcode with the record ID -->
                <script type="text/javascript">
                  if (typeof JsBarcode !== 'undefined') {
                    // Get the SVG element for the QR code
                    const qrcodeSvg = document.getElementById("qrcode");
                  
                    // Generate QR code using QRCode
                    var qrcode = new QRCode(qrcodeSvg, {
                      text: '${id}',
                      width: 128,
                      height: 128,
                    });
                    
                    // Get the SVG element for the barcode
                    const barcodeSvg = document.getElementById("barcode");
                  
                    // Generate barcode using JsBarcode
                    JsBarcode(barcodeSvg, '${id}', {
                      format: "CODE128",
                      displayValue: true,
                      fontSize: 14,
                      textMargin: 10,
                    });
                   
                    const textElement = barcodeSvg.querySelector('text');
                    if (textElement) {
                      textElement.remove();
                    }
                    // Set the desired width directly in the SVG element for the barcode
                    barcodeSvg.setAttribute('width', '128'); // Adjust the width here
                  
                    // Set the desired height directly in the SVG element for the barcode
                    barcodeSvg.setAttribute('height', '80'); // Adjust the height here
                  
                    // Disable aspect ratio preservation for the barcode
                    barcodeSvg.setAttribute('preserveAspectRatio', 'none');
                  
                    // Add spacing between the QR code and the barcode
                    qrcodeSvg.style.marginBottom = '20px'; // Adjust the margin here
                  } else {
                    console.error('JsBarcode library not loaded.');
                  }
                </script>
              </div>
            </body>
          </html>
          `);


        // Close the print window after printing
        printWindow.document.close();


    };







    const formatParticipantData = (participantData) => {
        const wppyamentArray = Array.isArray(participantData.wppyament) ? participantData.wppyament : [];

        // Extracting the total payment from the first element of wppyament array
        const totalPayment = wppyamentArray.length > 0
            ? wppyamentArray[0].total_payment
            : '0.00';
        const grandTotalPayment = wppyamentArray.length > 0
            ? wppyamentArray[0].grand_total_payment
            : '0.00';


        const wppyamentypeArray = Array.isArray(participantData.wppyament) ? participantData.wppyament : [];
        const payment_type = wppyamentypeArray.length > 0
            ? wppyamentypeArray[0].payment_type
            : 'null';

        const wppyamenstatusArray = Array.isArray(participantData.wppyament) ? participantData.wppyament : [];
        const payment_status = wppyamenstatusArray.length > 0
            ? wppyamenstatusArray[0].status
            : 'null';

        const wppyamensendemailArray = Array.isArray(participantData.wppyament) ? participantData.wppyament : [];
        const payment_send_email = wppyamensendemailArray.length > 0
            ? wppyamensendemailArray[0].send_email
            : 'null';

        const wppyamensendsmsArray = Array.isArray(participantData.wppyament) ? participantData.wppyament : [];
        const payment_send_sms = wppyamensendsmsArray.length > 0
            ? wppyamensendsmsArray[0].send_sms
            : 'null';

        // Accessing the category name through the wpcategory relationship
        const categoryName = participantData.wpcategory
            ? participantData.wpcategory.workshop_category_title
            : 'Unknown Category';

        const workshopCodes = participantData.wpworkshop
            ? participantData.wpworkshop.map((workshop) => workshop.workshop_code)
            : [];


        const wppyamenRefnoArray = Array.isArray(participantData.wppyament) ? participantData.wppyament : [];
        const trans_ref_no = wppyamenRefnoArray.length > 0
            ? wppyamenRefnoArray[0].trans_ref_no
            : 'null';

        const wppyamenPaymentMethodArray = Array.isArray(participantData.wppyament) ? participantData.wppyament : [];
        const payment_method = wppyamenPaymentMethodArray.length > 0
            ? wppyamenRefnoArray[0].payment_method
            : 'null';


        return {
            'Invoice ID': `INV${participantData.id}`,
            ...(trans_ref_no !== null && trans_ref_no !== undefined ? { 'Transaction Ref': trans_ref_no } : {}),
            'User ID / Receipt No': `${participantData.id}`,
            'Amount': `${totalPayment}`,
            'Grand Total': `${grandTotalPayment}`,
            'Registration': `${categoryName}: ${workshopCodes.length > 0 ? workshopCodes.join(', ') : 'No Workshops'}`,
            'Payment Type': `${payment_type}`,
            'Payment Method': `${payment_method}`,

            'Payment Paid': `${payment_status == 0 ? "Not Paid" : "Paid"}`,
            'Sent Mail': `${payment_send_email == 0 ? "Not Send" : "Send"}`,
            'Send Receipt': `${payment_send_sms == 0 ? "Not Send" : "Send"}`,
            'Date Time': participantData.created_at,
            'Payment Paid Date Time': participantData.updated_at,
        };
    };


    const formattedInvoiceData = formatParticipantData(participantSingleData);


    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,


    return (
        <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>

                <Card sx={{ width: '82vw', float: 'center' }} >
                    <CardContent >

                        <Box component="form" noValidate sx={{ mt: 3 }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography component="h1" variant="h5">
                                    WorkShop Participants Order
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span>Total Records: {totalRecords}</span>
                                    <span style={{ marginLeft: '10px' }}>|</span>
                                    <span style={{ marginLeft: '10px' }}>Filtered Records: {filteredRecordsCount}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Grid item xs={4} style={{ marginRight: '10px' }}>
                                        <TextField
                                            fullWidth
                                            label="Filter By: All"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={4} style={{ marginRight: '10px' }}>
                                        <TextField
                                            fullWidth
                                            label="Filter By: BarcodeID"
                                            value={searchTermID}
                                            onChange={(e) => setSearchTermID(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Select value={filterPaymentStatus} onChange={handleFilterPaymentStatusChange}>
                                            <MenuItem value="all">All</MenuItem>
                                            <MenuItem value="paid">Paid</MenuItem>
                                            <MenuItem value="unpaid">Unpaid</MenuItem>
                                        </Select>
                                    </Grid>
                                </div>


                            </div>
                            {
                                permissions['p_workshop-participant-add'] === true ?

                                    <Button sx={{
                                        float: 'right',
                                        marginTop: '2%',
                                        backgroundColor: backGroundButtonByEvent,
                                        ":hover": {
                                            color: "white"
                                        }
                                    }}
                                        color='success'
                                        size='small'
                                        variant='contained'
                                        component={Link}
                                        to="/admin/workshop/particpant">
                                        Add New
                                    </Button> : ""}
                            {
                                permissions['p_workshop-order-export'] === true ?
                                    <Button
                                        onClick={handleWorkshopDownloadCSV}
                                        sx={{
                                            float: 'right',
                                            marginRight: '1%',
                                            marginTop: '2%',
                                            backgroundColor: backGroundButtonByEvent,
                                            ":hover": {
                                                color: "white"
                                            }
                                        }}
                                        color='success'
                                        size='small'
                                        variant='contained'
                                    >
                                        <FileDownloadIcon />
                                        Download CSV
                                    </Button>
                                    : ""}

                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>User ID</TableCell>
                                            <TableCell align="left">Full Name</TableCell>
                                            <TableCell align="left">Workshops</TableCell>
                                            <TableCell align="left">Registration</TableCell>
                                            <TableCell align="left">Paid Amount</TableCell>
                                            <TableCell align="left">Payment Type</TableCell>
                                            <TableCell align="left">Payment Status</TableCell>
                                            <TableCell align="left">Ref No</TableCell>
                                            {/* <TableCell align="left">Recipt Sent</TableCell> */}
                                            <TableCell align="left">Payment Method</TableCell>
                                            <TableCell align="left">Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {filteredPosts && filteredPosts.slice(startIndex, endIndex).map((row, index) => (

                                            <TableRow key={index}>
                                                <>

                                                    <TableCell>{row.id}</TableCell>
                                                    <TableCell>{row.name_title}: {row.particent_name}</TableCell>
                                                    <TableCell style={{ width: '20%' }}>
                                                    {row.wpworkshop.map((rowWorkshop, index) => (
                                                        <React.Fragment key={index}>
                                                            <div>{rowWorkshop.workshop_name}</div><br></br>
                                                        </React.Fragment>
                                                    ))}
                                                </TableCell>
                                                    <TableCell>{row.wpcategory.workshop_category_title}</TableCell>


                                                    <TableCell>
                                                        {row.wppyament.map((wppyament, index) => (
                                                            <div key={index}>{wppyament.total_paid_amount === '0.0000' ? wppyament.total_paid_amount : wppyament.grand_total_payment  }</div>
                                                        ))}
                                                    </TableCell>

                                                    <TableCell>
                                                        {row.pp_ledger && row.pp_ledger.map((ledger, index) => (
                                                            <div key={index}>{ledger.payment_type}</div>
                                                        ))
                                                        }
                                                    </TableCell>


                                                    <TableCell>
                                                        {row.wppyament.map((wppyament, index) => (
                                                            <div key={index}>{wppyament.status === 0 ? 'No' : 'Yes'}</div>
                                                        ))}
                                                    </TableCell>

                                                    <TableCell>
                                                        {row.wppyament.map((wppyament, index) => (
                                                            <div key={index}>
                                                                {
                                                                    wppyament.trans_ref_no === "" || wppyament.trans_ref_no === null ? "" :
                                                                        <Button variant="outlined" onClick={() => handleModalChallan(wppyament)} sx={{ backgroundColor: backGroundButtonByEvent, color: "white", ":hover": { color: backGroundButtonByEvent }, }}>
                                                                            View Challan</Button>
                                                                }
                                                            </div>
                                                        ))}

                                                    </TableCell>



                                                    <TableCell>

                                                        {row.wppyament.map((wppyament, index) => (
                                                            <div key={index} >{wppyament.payment_method}</div>
                                                        ))}
                                                        <hr></hr>
                                                        {row.pp_ledger && row.pp_ledger.map((ledger, index) => (

                                                            <div key={index}>.{ledger.payment_method}/{ledger.workshop_amount}</div>
                                                        ))
                                                        }
                                                    </TableCell>


                                                    < TableCell >
                                                        {permissions['p_workshop-order-verifiction'] === true && row.wppyament.some((wppyament) => wppyament.status === 0) ? (
                                                            <Select
                                                                value={selectedOptions[row.id] || ''}
                                                                onChange={(event) => handleChange(event, row)}
                                                                displayEmpty
                                                                inputProps={{ 'aria-label': 'Verify' }}
                                                                sx={{ width: '100%' }}
                                                            >
                                                                <MenuItem value="" disabled>Verify</MenuItem>
                                                                <MenuItem onClick={() => handleSelection('receipt', row)} value="receipt">Receipt</MenuItem>
                                                                <MenuItem onClick={() => handleSelection('bank', row)} value="bank">Bank</MenuItem>
                                                                {/* <MenuItem onClick={() => handleSelection('cash', row)} value="cash">Cash</MenuItem> */}
                                                                <MenuItem onClick={() => handleSelection('qrcodeshow', row)} value="qrcodeshow">Display QrCode</MenuItem>
                                                            </Select>
                                                        ) : ''}

                                                        <div>
                                                            <Button
                                                                sx={{
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    marginTop: 1,
                                                                    marginBottom: 1,
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                onClick={() => handleClickView(row.id)}
                                                            >
                                                                View
                                                            </Button>
                                                        </div>


                                                        {row.wppyament.some((wppyament) => wppyament.status === 0) ? null : (
                                                            <div>
                                                                <Button
                                                                    sx={{
                                                                        ":hover": { color: "white" },
                                                                        backgroundColor: backGroundButtonByEvent,
                                                                        marginTop: 1,
                                                                        marginBottom: 1,
                                                                    }}
                                                                    color='primary'
                                                                    size='small'
                                                                    variant='contained'
                                                                    onClick={() => handleBarcodeClick(row)}
                                                                >
                                                                    QrCode
                                                                </Button>
                                                            </div>
                                                        )}


                                                        <div>
                                                            {/* {
                                                                permissions['p_workshop-order-view-workshop-verifiction'] === true ? */}
                                                            {
                                                                permissions['p_workshop-order-view-workshop-verifiction'] === true && row.wppyament.some((wppyament) => wppyament.status === 1) ? (
                                                                    <Button
                                                                        sx={{
                                                                            ":hover": { color: "white" },
                                                                            backgroundColor: backGroundButtonByEvent,
                                                                            marginTop: 1,
                                                                            marginBottom: 1,
                                                                        }}
                                                                        color='primary'
                                                                        size='small'
                                                                        variant='contained'
                                                                        onClick={() => handleClickViewWorkshops(row.id)}
                                                                    >
                                                                        View Workshops
                                                                    </Button>
                                                                ) : ''}
                                                        </div>
                                                        {/* commemnt for only scmfs Conference boz its free conference */}
                                                        {row.wppyament.some((wppyament) => wppyament.status === 1) ? null : (
                                                        <div>
                                                            <Button
                                                                sx={{
                                                                    marginBottom: 1,
                                                                    marginTop: 1,
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    position: 'relative',
                                                                    '& .MuiButton-endIcon': {
                                                                        borderLeft: '1px solid white',
                                                                        padding: '0 6px',
                                                                        marginLeft: '20px',
                                                                    }
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                endIcon={<span>{row.reminder_count || 0}</span>}
                                                                // onClick={handleClickReminderEmail}
                                                                onClick={() => handleClickReminderEmail(row)}
                                                                disabled={isButtonReminderDisabled}
                                                            >
                                                                Reminder Email
                                                            </Button>
                                                        </div>
                                                        )}
                                                        {/* <div>
                                                            <Button
                                                                sx={{
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    position: 'relative',
                                                                    '& .MuiButton-endIcon': {
                                                                        borderLeft: '2px solid white',
                                                                        padding: '0 8px',
                                                                        marginLeft: '25px',
                                                                    }
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                endIcon={<span>0 </span>}
                                                                onClick={handleClickReminderSMS}
                                                            >
                                                                Reminder SMS
                                                            </Button>
                                                        </div> */}
                                                    </TableCell>


                                                </>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000, 10000, 100000]}
                                    component="div"
                                    count={filteredRows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>


                        </Box>
                    </CardContent>
                </Card>
            </Box>



            <Dialog
                component="form"
                onSubmit={addReceiptData}
                open={openModalReceipt}
                onClose={handleCloseModal} >
                <DialogTitle>Add Receipt / Cash Detail</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Invoice No"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name='particent_id'
                        value={`INV${participantSingleData.id || ""}`}

                        disabled={true}
                    // No need for onChange if you want it to be read-only
                    // onChange={(e) => setAddReceipt({ ...addReceipt, particent_id: e.target.value })}
                    />
                    <TextField
                        label="Bank Name / Cash"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="particent_bank"
                        value={addReceipt.particent_bank || ""}

                        onChange={handleInputReceipt}

                    />
                    <TextField
                        label="Ref Number"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="particent_ref_no"
                        value={addReceipt.particent_ref_no}
                        //onChange={(e) => setAddReceipt({ ...addReceipt, particent_ref_no: e.target.value })}
                        onChange={handleInputReceipt}
                    // Add any additional TextField props or styles as needed
                    />
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {participantSingleData?.wpworkshop?.map((workshop, key) => {
                                    const participantId = participantSingleData?.id || ''; // Ensure participantSingleData is not null or undefined
                                    const workshopId = workshop?.id || ''; // Ensure workshop is not null or undefined

                                    // Initialize variables for discounted amount and coupon code
                                    let discountedAmount = workshop.workshop_amount; // Default to original workshop amount
                                    let couponCodeDisplay = ''; // Initialize to empty string

                                    if (participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0) {
                                        // Filter and map coupon codes for the current workshop
                                        participantSingleData.coupon_codes
                                            .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                                            .forEach((coupon, couponIndex) => {
                                                // Determine the discount based on the coupon type
                                                let discount = 0;
                                                if (coupon.coupon_discount_type === 'fixed') {
                                                    discount = parseFloat(coupon.coupon_amount);
                                                } else if (coupon.coupon_discount_type === 'percentage') {
                                                    // Calculate the percentage discount
                                                    const percentage = parseFloat(coupon.coupon_amount);
                                                    discount = (parseFloat(workshop.workshop_amount) * percentage) / 100;
                                                }
                                                // Calculate the final amount after discount
                                                discountedAmount -= discount;
                                                // Add the coupon code to the display
                                                couponCodeDisplay += coupon.coupon_code + ', ';
                                            });

                                        // Remove the trailing comma and space
                                        couponCodeDisplay = couponCodeDisplay.slice(0, -2);
                                    }


                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{workshop.workshop_name} : ID {workshop.workshop_id}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{workshop.workshop_code}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>
                                                {/* {workshop.payment_status === 0 ? (
                                                    <Checkbox
                                                        checked={checkedWorkshops[workshop.id] || false}
                                                        onChange={() => handleWrokshopCheckboxChange(workshop.id)}
                                                    />
                                                ) : (
                                                    "Paid"
                                                )} */}


                                                {workshop.payment_status === 0 ? (

                                                    <Checkbox
                                                        checked={checkedWorkshops[workshop.id] || false}
                                                        onChange={() => handleWrokshopCheckboxChange(workshop.id)}
                                                        disabled={isCheckboxDisabled(workshop).isDisabled} />

                                                ) : (
                                                    "Paid"
                                                )}
                                                <br></br>
                                                {isCheckboxDisabled(workshop).seatLimitMessage && (
                                                    <span style={{ color: 'red' }}>
                                                        {isCheckboxDisabled(workshop).seatLimitMessage}
                                                    </span>
                                                )}


                                            </TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{discountedAmount}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>

                                                {participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0 ? (
                                                    // Filter and map coupon codes for the current workshop
                                                    participantSingleData.coupon_codes
                                                        .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                                                        .map((coupon, couponIndex) => (
                                                            <span key={couponIndex}>
                                                                {coupon.coupon_discount_type === 'percentage' ? (
                                                                    <span>Coupon percent: {coupon.coupon_amount}</span>
                                                                ) : (
                                                                    <span>Coupon Amount: {coupon.coupon_amount}</span>
                                                                )}
                                                                <br />
                                                                Coupon Code: {coupon.coupon_code}
                                                            </span>
                                                        ))
                                                ) : (
                                                    <span>No coupons available</span>
                                                )}

                                            </TableCell>
                                        </TableRow>
                                    );
                                })}

                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalDiscountedAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Paid:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Remining:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalUnPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Grand Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{grandTotalViewWorkshopAmountFormatted}</TableCell>
                                </TableRow>

                            </TableBody>

                        </Table>
                    </TableContainer>
                </DialogContent>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 2 }}
                    disabled={isSaveButtonDisabled}
                >
                    Save
                </Button>
            </Dialog>


            <Dialog
                component="form"
                onSubmit={submitBankData}
                open={openModalBank}
                onClose={handleCloseModalBank}>
                <DialogTitle>Add Bank Details</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Invoice No"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name='particent_id'
                        value={`INV${participantSingleData.id || ""}`}
                        disabled={true} />
                    <TextField
                        label="Bank Name"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={(addBank.bank_name ? addBank.bank_name : bankNameforVeri.join('  ,  ')) || ''}
                        onChange={(e) => setAddBank({ ...addBank, bank_name: e.target.value })}

                    />
                    <TextField
                        label="Ref Number"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={(addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join('  ,  ')) || ""}
                        onChange={(e) => setAddBank({ ...addBank, trans_ref_no: e.target.value })} />


                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {participantSingleData?.wpbank_pay_tran?.map((bankDeatials, key) => (
                                    <TableRow key={key}>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{bankDeatials.bank_name}</TableCell>
                                        <TableCell>
                                            {
                                                bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "" :

                                                    <Button variant="outlined" onClick={() => handleModalBankReciept(bankDeatials)}>
                                                        {bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "null" : bankDeatials.trans_ref_no}
                                                    </Button>
                                            }

                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>

                        </Table>
                    </TableContainer>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>

                                {participantSingleData?.wpworkshop?.map((workshop, key) => {
                                    const participantId = participantSingleData?.id || ''; // Ensure participantSingleData is not null or undefined
                                    const workshopId = workshop?.id || ''; // Ensure workshop is not null or undefined

                                    // Initialize variables for discounted amount and coupon code
                                    let discountedAmount = workshop.workshop_amount; // Default to original workshop amount
                                    let couponCodeDisplay = ''; // Initialize to empty string

                                    if (participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0) {
                                        // Filter and map coupon codes for the current workshop
                                        participantSingleData.coupon_codes
                                            .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                                            .forEach((coupon, couponIndex) => {
                                                // Determine the discount based on the coupon type
                                                let discount = 0;
                                                if (coupon.coupon_discount_type === 'fixed') {
                                                    discount = parseFloat(coupon.coupon_amount);
                                                } else if (coupon.coupon_discount_type === 'percentage') {
                                                    // Calculate the percentage discount
                                                    const percentage = parseFloat(coupon.coupon_amount);
                                                    discount = (parseFloat(workshop.workshop_amount) * percentage) / 100;
                                                }
                                                // Calculate the final amount after discount
                                                discountedAmount -= discount;
                                                // Add the coupon code to the display
                                                couponCodeDisplay += coupon.coupon_code + ', ';
                                            });

                                        // Remove the trailing comma and space
                                        couponCodeDisplay = couponCodeDisplay.slice(0, -2);
                                    }


                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{workshop.workshop_name} : ID {workshop.workshop_id}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{workshop.workshop_code}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>
                                                {/* {workshop.payment_status === 0 ? (
                                                    <Checkbox
                                                        checked={checkedWorkshops[workshop.id] || false}
                                                        onChange={() => handleWrokshopCheckboxChange(workshop.id)}
                                                    />
                                                ) : (
                                                    "Paid"
                                                )} */}
                                                {workshop.payment_status === 0 ? (

                                                    <Checkbox
                                                        checked={checkedWorkshops[workshop.id] || false}
                                                        onChange={() => handleWrokshopCheckboxChange(workshop.id)}
                                                        disabled={isCheckboxDisabled(workshop).isDisabled} />

                                                ) : (
                                                    "Paid"
                                                )}
                                                <br></br>
                                                {isCheckboxDisabled(workshop).seatLimitMessage && (
                                                    <span style={{ color: 'red' }}>
                                                        {isCheckboxDisabled(workshop).seatLimitMessage}
                                                    </span>
                                                )}

                                            </TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{discountedAmount}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>

                                                {participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0 ? (
                                                    // Filter and map coupon codes for the current workshop
                                                    participantSingleData.coupon_codes
                                                        .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                                                        .map((coupon, couponIndex) => (
                                                            <span key={couponIndex}>
                                                                {coupon.coupon_discount_type === 'percentage' ? (
                                                                    <span>Coupon percent: {coupon.coupon_amount}</span>
                                                                ) : (
                                                                    <span>Coupon Amount: {coupon.coupon_amount}</span>
                                                                )}
                                                                <br />
                                                                Coupon Code: {coupon.coupon_code}
                                                            </span>
                                                        ))
                                                ) : (
                                                    <span>No coupons available</span>
                                                )}

                                            </TableCell>


                                        </TableRow>
                                    );
                                })}
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalDiscountedAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Paid:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Remining:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalUnPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Grand Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{grandTotalViewWorkshopAmountFormatted}</TableCell>
                                </TableRow>

                            </TableBody>

                        </Table>
                    </TableContainer>
                </DialogContent>

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 2 }}
                    disabled={isSubmitting || isSaveButtonDisabled}
                >
                    {isSubmitting ? 'Submitting...' : 'Save'}

                </Button>
            </Dialog>





            <Dialog open={openModalBankVeriChallan} onClose={handleCloseModalBankVeriChallan}>
                <DialogTitle>Bank challan</DialogTitle>
                <DialogActions>
                    <TableContainer component={Paper} >
                        <Table sx={{ minWidth: 350 }} aria-label="simple table" >
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Bank Name</TableCell>
                                    <TableCell align="right">Method</TableCell>
                                    <TableCell align="right">Ref&nbsp;(no)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {participantSingleData?.wpbank_pay_tran?.map((bankDeatials, key) => (
                                    <TableRow key={key}>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{bankDeatials.bank_name}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }} align="right">{bankDeatials.payment_type}</TableCell>
                                        <TableCell align="right">
                                            {
                                                bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "" :

                                                    <Button variant="outlined" onClick={() => handleModalBankReciept(bankDeatials)}>
                                                        {bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "null" : bankDeatials.trans_ref_no}
                                                    </Button>
                                            }

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogActions>

                <DialogContent>
                    <Tabs value={tabValueReceipt} onChange={handleReceiptTabChange} aria-label="Tabs">
                        {tabsDataReceipt.map((tab, index) => (
                            <Tab key={index} label={tab.label} />
                        ))}
                    </Tabs>
                    <div style={{ overflowX: 'auto', maxHeight: '300px' }}>
                        {tabsDataReceipt.map((item, index) => (
                            <div key={index}>
                                {tabValueReceipt === index && (
                                    <DialogContentText id={`item-${index}-content`}>
                                        <img src={item.imageUrl} alt={`Image ${index}`} style={{ maxWidth: '100%', height: 'auto' }} />
                                    </DialogContentText>
                                )}
                            </div>
                        ))}
                    </div>
                </DialogContent>





            </Dialog>











            <Dialog open={openModalView} onClose={handleCloseModalView}>
                <DialogTitle>Invoice Detail {participantSingleData?.id || ""}</DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {Object.keys(formattedInvoiceData).map((key) => (
                                    <TableRow key={key}>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{formattedInvoiceData[key]}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>


                    </TableContainer>
                </DialogContent>

            </Dialog>

            <Dialog open={openModalWorkshop} onClose={handleCloseModalWorkshop}>
                <DialogTitle>  {participantSingleData?.particent_name || ""}  </DialogTitle>
                <DialogContent>
                    <TextField
                        label="Invoice No"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name='particent_id'
                        value={`INV${participantSingleData.id || ""}`}
                        disabled={true} />
                    <TextField
                        label="Bank Name"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={(addBank.bank_name ? addBank.bank_name : bankNameforVeri.join('  ,  ')) || ''}
                        onChange={(e) => setAddBank({ ...addBank, bank_name: e.target.value })}

                    />

                    <TextareaAutosize
                        aria-label="Ref Number"
                        placeholder="Ref Number"
                        minRows={3}
                        maxRows={6}
                        value={(addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join('  ,  ')) || ""}
                        onChange={(e) => setAddBank({ ...addBank, trans_ref_no: e.target.value })}
                    />

                    <TableContainer component={Paper}>
                        <Table>

                            <TableBody>
                                {participantSingleData?.wpworkshop?.map((workshop, key) => {
                                    const participantId = participantSingleData?.id || ''; // Ensure participantSingleData is not null or undefined
                                    const workshopId = workshop?.id || ''; // Ensure workshop is not null or undefined

                                    // Initialize variables for discounted amount and coupon code
                                    let discountedAmount = workshop.workshop_amount; // Default to original workshop amount
                                    let couponCodeDisplay = ''; // Initialize to empty string

                                    if (participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0) {
                                        // Filter and map coupon codes for the current workshop
                                        participantSingleData.coupon_codes
                                            .filter(coupon => coupon.workshop_id === workshop.workshop_id) // Filter by workshop ID
                                            .forEach((coupon, couponIndex) => {
                                                // Determine the discount based on the coupon type
                                                let discount = 0;
                                                if (coupon.coupon_discount_type === 'fixed') {
                                                    discount = parseFloat(coupon.coupon_amount);
                                                } else if (coupon.coupon_discount_type === 'percentage') {
                                                    // Calculate the percentage discount
                                                    const percentage = parseFloat(coupon.coupon_amount);
                                                    discount = (parseFloat(workshop.workshop_amount) * percentage) / 100;
                                                }
                                                // Calculate the final amount after discount
                                                discountedAmount -= discount;
                                                // Add the coupon code to the display
                                                couponCodeDisplay += coupon.coupon_code + ', ';
                                            });

                                        // Remove the trailing comma and space
                                        couponCodeDisplay = couponCodeDisplay.slice(0, -2);
                                    }


                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{workshop.workshop_name} : ID {workshop.workshop_id}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{workshop.workshop_code}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>
                                                {/* {workshop.payment_status === 0 ? (
                                                    <Checkbox
                                                        checked={checkedWorkshops[workshop.id] || false}
                                                        onChange={() => handleWrokshopCheckboxChange(workshop.id)}
                                                    />
                                                ) : (
                                                    "Paid"
                                                )} */}
                                                {workshop.payment_status === 0 ? (

                                                    <Checkbox
                                                        checked={checkedWorkshops[workshop.id] || false}
                                                        onChange={() => handleWrokshopCheckboxChange(workshop.id)}
                                                        disabled={isCheckboxDisabled(workshop).isDisabled} />

                                                ) : (
                                                    "Paid"
                                                )}
                                                <br></br>
                                                {isCheckboxDisabled(workshop).seatLimitMessage && (
                                                    <span style={{ color: 'red' }}>
                                                        {isCheckboxDisabled(workshop).seatLimitMessage}
                                                    </span>
                                                )}




                                            </TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{discountedAmount}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>
                                                {participantSingleData.coupon_codes && participantSingleData.coupon_codes.length > 0 ? (
                                                    participantSingleData.coupon_codes
                                                        .filter(coupon => coupon.workshop_id === workshop.workshop_id)
                                                        .map((coupon, couponIndex) => (
                                                            <div key={couponIndex} style={{ marginBottom: '8px' }}>
                                                                {coupon.coupon_discount_type === 'percentage' ? (
                                                                    <div>Coupon percent: {coupon.coupon_amount}</div>
                                                                ) : (
                                                                    <div>Coupon Amount: {coupon.coupon_amount}</div>
                                                                )}
                                                                <div>Coupon Code: {coupon.coupon_code}</div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div>No coupons available</div>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}

                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalDiscountedAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Paid:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Remining:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalUnPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Grand Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{grandTotalViewWorkshopAmountFormatted}</TableCell>
                                </TableRow>

                            </TableBody>

                        </Table>


                    </TableContainer>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <Button onClick={handleWorkshopStatusSubmit} variant="contained" color="primary" disabled={isSaveButtonDisabled}>submit</Button>
                    </div>

                </DialogContent>
                <DialogContent>

                    <Tabs value={tabValueReceipt} onChange={handleReceiptTabChange} aria-label="Tabs">
                        {tabsDataReceipt.map((tab, index) => (
                            <Tab key={index} label={tab.label} />
                        ))}
                    </Tabs>

                    <div style={{ overflowX: 'auto', maxHeight: '300px' }}>
                        {tabsDataReceipt.map((tab, index) => (
                            <div key={index} hidden={tabValueReceipt !== index}>
                                <DialogContentText id={`tab-${index}-content`}>
                                    <span>{tab.content}</span>
                                    {/* {tab.imageUrl === "Receipt" ? null : <img src={tab.imageUrl} alt={tab.label} width="450" />} */}
                                    {tab.imageUrl === "Receipt" ? null : <img src={tab.imageUrl} alt={tab.label} style={{ maxWidth: '100%', height: 'auto' }}/>} 
                                    {/* <img src={tab.imageUrl} alt={`Image ${index}`} style={{ maxWidth: '100%', height: 'auto' }} /> */}
                                </DialogContentText>
                            </div>
                        ))}
                    </div>
                </DialogContent>


            </Dialog>

            <Dialog open={openModalChallan} onClose={handleCloseModalChallan} >
                <DialogTitle>challan</DialogTitle>
                <DialogActions>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 350 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Bank Name</TableCell>
                                    <TableCell align="right">Method</TableCell>
                                    <TableCell align="right">Ref&nbsp;(no)</TableCell>
                                    <TableCell align="right">Discount</TableCell>
                                    <TableCell align="right">Grand&nbsp;(total)</TableCell>
                                    <TableCell align="right">Total&nbsp;(Paid)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow
                                    key={challandata.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">{challandata.bank_name}</TableCell>
                                    <TableCell align="right">{challandata.payment_method}</TableCell>
                                    <TableCell align="right">{challandata.trans_ref_no}</TableCell>
                                    <TableCell align="right">{challandata.workshop_discount}</TableCell>
                                    <TableCell align="right">{challandata.grand_total_payment}</TableCell>
                                    <TableCell align="right">{challandata.total_paid_amount}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogActions>
                {challandata.receipt_image !== "no_image.jpg" && challandata.receipt_image !== null && (
                    <DialogContent sx={{ width: "550px", height: "400px" }}>
                        <DialogTitle id="alert-dialog-title">
                            <a href={`${challandata.base_url}/workshop/${challandata.receipt_image}`} target="_blank">
                                <img src={`${challandata.base_url}/workshop/${challandata.receipt_image}`} width="450" alt="Receipt" />
                            </a>
                        </DialogTitle>
                    </DialogContent>
                )}
            </Dialog>








        </div >







    );
}
export default MangeWorkShopParticpantOrder;
